import {defineStore} from 'pinia'

const name = 'appPush'

let init = {
  supported: false,
  permission: 'default',   // 'default' | 'granted' | 'denied'
  subscribed: false,
  busy: false,
}

export const useAppPushStore = defineStore(name, {
  id: name,

  state: () => ({...init}),

  actions: {
    setSupported(payload) { this.supported = payload },
    setPermission(payload) { this.permission = payload },
    setSubscribed(payload) { this.subscribed = payload },
    setBusy(payload) { this.busy = payload },
  },

  getters: {
    // Notifications réellement actives sur cet appareil.
    isEnabled: (state) => state.subscribed && state.permission === 'granted',
    // L'utilisateur a bloqué les notifications dans le navigateur.
    isBlocked: (state) => state.permission === 'denied',
  },
})
